import { CacheProvider } from '@emotion/react'
import { HeadlessMantineProvider } from '@mantine/core'
import { QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from '@tanstack/react-router'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import queryClient from './utils/queryClient'
import router from './utils/router'
import Sentry from './utils/sentry'
import styleCache from './utils/styleCache'

Sentry.init()

const root = createRoot(document.getElementById('root') as HTMLElement)

const App = Sentry.withProfiler(
	() => {
		return (
			<StrictMode>
				<QueryClientProvider client={queryClient}>
					<CacheProvider value={styleCache}>
						<HeadlessMantineProvider>
							<RouterProvider router={router} />
						</HeadlessMantineProvider>
					</CacheProvider>
				</QueryClientProvider>
			</StrictMode>
		)
	},
	{
		name: 'App',
	}
)

root.render(<App />)
